import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Es para principiantes?',
  answer: 'No. Es para personas que ya venden y quieren orden y retorno.'
}, {
  question: '¿Es en vivo o grabado?',
  answer: 'Es en vivo por Zoom. Tendrás acceso a la grabación.'
}, {
  question: '¿Necesito experiencia previa?',
  answer: 'Necesitas vender o liderar un proceso comercial.'
}, {
  question: '¿Qué necesito para aprovecharlo?',
  answer: 'Papel, lápiz y disposición a tomar decisiones.'
}, {
  question: '¿Por qué cuesta solo $15?',
  answer: 'Porque no compras contenido. Compras claridad y estructura en 90 minutos.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Si asistes en vivo y no sales con claridad y decisiones tomadas, se devuelve.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 px-6 bg-slate-50" data-id="element-6">
      <div className="max-w-3xl mx-auto" data-id="element-7">
        <h2 className="font-bold text-center text-slate-900 mb-12" style={{
        fontSize: '28px'
      }} data-id="element-8">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-9">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-10">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-11">
                <span className="font-bold text-slate-900 text-lg" data-id="element-12">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-orange-500" data-id="element-13" /> : <ChevronDown className="w-5 h-5 text-slate-400" data-id="element-14" />}
              </button>
              <AnimatePresence data-id="element-15">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-16">
                    <div className="px-6 pb-6 text-slate-600 leading-relaxed" data-id="element-17">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}